<div class="background"></div>
<div class="foreground">
  <load-guard [host]="this">
    <ng-container *ngIf="!ready && !failedToLoad">
      <app-spinner></app-spinner>
    </ng-container>

    <ng-container *ngIf="ready && !failedToLoad">
      <div class="sticky-signup-c2a" *ngIf="showSignupC2A">
        <a routerLink="/signup" (click)="setUserSource('home_page_mobile_signup_c2a')">
          Create a Free Account
          <mat-icon>chevron_right</mat-icon>
        </a>
      </div>
      <div class="carousel">
        <div>
          <app-carousel class="mobile-display" *ngIf="!carouselSlides || carouselSlides.length > 0">

            <!-- render only one slide on SSR -->
            <ng-container *ngIf="serverSide && carouselSlides">
              <app-carousel-item [responsiveBackgroundImage]="carouselSlides[0].image" [url]="carouselSlides[0].url">
              </app-carousel-item>
            </ng-container>

            <!-- full carousel set (client-side, mobile) -->
            <ng-container *ngIf="!serverSide">
              <ng-container *ngFor="let slide of carouselSlides">
                <ng-container *ngIf="isAudience(slide.intended_audience)">
                  <app-carousel-item [responsiveBackgroundImage]="slide.image" [url]="slide.url">
                  </app-carousel-item>
                </ng-container>
              </ng-container>
            </ng-container>
          </app-carousel>
          <app-carousel class="desktop-display" *ngIf="!carouselSlides || carouselSlides.length > 0">

            <!-- render only one slide on SSR -->
            <ng-container *ngIf="serverSide && carouselSlides">
              <app-carousel-item [responsiveBackgroundImage]="carouselSlides[0].image_desktop"
                [url]="carouselSlides[0].url">
              </app-carousel-item>
            </ng-container>

            <!-- full carousel set (client-side, desktop) -->
            <ng-container *ngIf="!serverSide">
              <ng-container *ngFor="let slide of carouselSlides">
                <ng-container *ngIf="slide.intended_audience.includes(audienceType)">
                  <app-carousel-item [responsiveBackgroundImage]="slide.image_desktop || slide.image" [url]="slide.url">
                  </app-carousel-item>
                </ng-container>
              </ng-container>
            </ng-container>
          </app-carousel>
        </div>
      </div>

      <div class="onboarding-c2a" *ngIf="onboarding">
        <ng-container *ngIf="!user">
          <div class="message">
            <span>
              <span class="placeholder"></span>
            </span>
          </div>

          <span class="placeholder" style="width: 8em"></span>
        </ng-container>
        <ng-container *ngIf="user">
          <div class="message">
            <span>
              <strong>Welcome {{user.display_name}}!</strong>
              Get started by picking your favorite topics, shows, and hosts now.
            </span>
          </div>
          <a class="page-action" routerLink="/settings/content/topics">
            Let's Go!
          </a>
        </ng-container>
      </div>

      <!-- CARDS -->

      <div class="devtools" *ngIf="enableDevTools">
        <mat-menu #typesMenu>
          <a mat-menu-item *ngFor="let cardType of cardTypes" (click)="addCard(cardType)">
            {{ cardType.devToolsLabel ?? cardType.id }}
          </a>
        </mat-menu>

        <mat-menu #devToolsMenu>
          <a mat-menu-item (click)="startEditingCards()">
            <mat-icon>edit</mat-icon>
            Edit Cards
          </a>
          <a mat-menu-item (click)="forceVisible = true" *ngIf="!forceVisible">
            <mat-icon>visibility</mat-icon>
            Force All Visible
          </a>
          <a mat-menu-item (click)="forceVisible = false" *ngIf="forceVisible">
            <mat-icon>visibility_off</mat-icon>
            Undo Force Visible
          </a>
          <a mat-menu-item [matMenuTriggerFor]="typesMenu">
            <mat-icon>add</mat-icon>
            Add Card
          </a>
          <a mat-menu-item (click)="showInfo = true" *ngIf="!showInfo">
            <mat-icon>info</mat-icon>
            Show Info
          </a>
          <a mat-menu-item (click)="showInfo = false" *ngIf="showInfo">
            <mat-icon>landscape</mat-icon>
            Hide Info
          </a>
        </mat-menu>
        {{ cards?.length ?? 0 }} cards, {{ primaryCards?.length ?? 0 }} primary, {{ secondaryCards?.length ?? 0 }} secondary
        <div class="spacer"></div>
        <button mat-button [matMenuTriggerFor]="devToolsMenu">
          <mat-icon>code</mat-icon>
          Tools
        </button>

        <button mat-icon-button (click)="enableDevTools = false">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <ng-container *ngIf="!editCards">
        <div class="two-column">
          <div class="primary">
            <tyt-home-card
              *ngFor="let card of primaryCards; index as i"
              [card]="card"
              [attr.data-shutter-order]="i"
              [showInfo]="showInfo"
              [forceVisible]="forceVisible"
              [primary]="cardIsPrimary(card)"
              (removed)="removeCard(card)"
              [enableDevTools]="enableDevTools"
              ></tyt-home-card>
          </div>
          <div class="secondary">
            <tyt-home-card
              *ngFor="let card of secondaryCards; index as i"
              [card]="card"
              [attr.data-shutter-order]="i"
              [showInfo]="showInfo"
              [forceVisible]="forceVisible"
              [primary]="cardIsPrimary(card)"
              (removed)="removeCard(card)"
              [enableDevTools]="enableDevTools"
              ></tyt-home-card>
          </div>
        </div>

        <div class="one-column">
          <tyt-home-card
            *ngFor="let card of cards; index as i"
            [card]="card"
            [primary]="cardIsPrimary(card)"
            [attr.data-shutter-order]="i"
            [showInfo]="showInfo"
            [forceVisible]="forceVisible"
            [primary]="cardIsPrimary(card)"
            (removed)="removeCard(card)"
            [enableDevTools]="enableDevTools"
            ></tyt-home-card>
        </div>
      </ng-container>
      <ng-container *ngIf="editCards">
        <form class="editor" (submit)="saveEditedCards()">
          <div class="buttons">
            <div>Editing Cards</div>
            <em>This applies only to the current page load.</em>
            <button mat-raised-button color="primary" (click)="saveEditedCards()">
              <mat-icon>done</mat-icon>
              Save
            </button>
            <button mat-button (click)="cancelEditingCards()">
              <mat-icon>close</mat-icon>
              Cancel
            </button>
          </div>

          <mat-form-field appearance="outline">
            <mat-label>JSON</mat-label>
            <textarea name="json" matInput autosize
              [(ngModel)]="cardJson"></textarea>
          </mat-form-field>

          <div class="buttons">
            <em>This applies only to the current page load.</em>
            <button mat-raised-button color="primary" (click)="saveEditedCards()">
              <mat-icon>done</mat-icon>
              Save
            </button>
            <button mat-button (click)="cancelEditingCards()">
              <mat-icon>close</mat-icon>
              Cancel
            </button>
          </div>
        </form>
      </ng-container>
    </ng-container>
    <div class="failed-to-load" *ngIf="failedToLoad">
      <h1>Uh oh...</h1>
      <p>Looks like we're having trouble loading this right now.</p>
    </div>
  </load-guard>
</div>